// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"82bedc14","453":"17c01f19","455":"a5210b5f","977":"1246a79a"}[chunkId] + ".chunk.js";
};